import OrderConfirmationContent from 'components/order-confirmation/OrderConfirmationContent';
import MainLayout from 'components/layout/MainLayout';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import LoadingSpinner from 'components/LoadingSpinner';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const OrderConfirmation2026 = observer(() => {
  const {
    userInitialized,
    currentUser,
    activeSubscriptions,
    activeWeeklyDrawTickets,
    isInMonthlyRaffle,
  } = useUserStore();
  const router = useRouter();

  useEffect(() => {
    if (userInitialized && !currentUser?.id) {
      router.push('/?fromOrderConfirmation=true');
    }
  }, [userInitialized, currentUser?.id]);

  if (
    !currentUser ||
    !activeSubscriptions ||
    !activeWeeklyDrawTickets ||
    !activeWeeklyDrawTickets.length ||
    activeSubscriptions.length === 0
  ) {
    return (
      <MainLayout limitItemWidths noHeaderDropShadow>
        <LoadingSpinner />
      </MainLayout>
    );
  }

  return (
    <MainLayout limitItemWidths noHeaderDropShadow>
      <OrderConfirmationContent
        currentEmailAddress={currentUser.emailAddress}
        activeSubscription={activeSubscriptions[0]}
        activeWeeklyDrawTickets={activeWeeklyDrawTickets}
        isInMonthlyRaffle={isInMonthlyRaffle}
      />
    </MainLayout>
  );
});

export default OrderConfirmation2026;
